<template>
	<b-modal id="ModalPaymentLoading" centered ref="modal" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
		<div class="loading-wrap">
			<div class="loading">
				<div class="loader"></div>
				<div class="text">로딩 중입니다.</div>
				<div class="subtext">잠시만 기다려주시기 바랍니다.</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: 'ModalPaymentLoading',
}
</script>

<style lang="scss">
#ModalPaymentLoading {
	.modal-dialog {
		width: 335px;
		height: 220px;
	}
	#ModalPaymentLoading___BV_modal_header_,
	#ModalPaymentLoading___BV_modal_footer_ {
		justify-content: center;
		.btn {
			width: 160px;
			height: 40px;
			&.btn-warning {
				background: $PRIMARY_YELLOW;
			}
		}
	}
	#ModalPaymentLoading___BV_modal_content_ {
		border-radius: 10px;
		#ModalPaymentLoading___BV_modal_body_ {
			text-align: center;
		}
	}
}
</style>

<style lang="scss" scoped>
.loader,
.loader:after {
	border-radius: 50%;
	width: 50px;
	height: 50px;
}
.loader {
	font-size: 10px;
	margin: 0 auto 15px;
	position: relative;
	text-indent: -9999em;
	border-top: 4px solid #f5f5f5;
	border-right: 4px solid #f5f5f5;
	border-bottom: 4px solid #f5f5f5;
	border-left: 4px solid #fec741;
	-webkit-transform: translateZ(0);
	-ms-transform: translateZ(0);
	transform: translateZ(0);
	-webkit-animation: load8 1.1s infinite linear;
	animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
	0% {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes load8 {
	0% {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

.loading-wrap {
	width: 100%;
	height: 200px;
	position: relative;
	.loading {
		position: absolute;
		width: 100%;
		top: calc(50% - 62px);
		left: 50%;
		transform: translateX(-50%) translateZ(0);
		text-align: center;
	}
	.text {
		margin-top: 30px;
		font-size: 1.125rem;
		font-weight: 700;
	}
	.subtext {
		margin-top: 5px;
		font-size: 0.875rem;
		font-weight: 500;
		color: $COLOR_999;
	}
}
</style>
